// codStatoPagamento
// Cod. SUCCESSO > Denominazione Successo
// Cod. FALLIMENTO > Denominazione Fallimento
// Cod. PENDENTE > Denominazione “Pendente”

export type EnumCodStatoPagamento =
  (typeof EnumCodStatoPagamento)[keyof typeof EnumCodStatoPagamento];

export const EnumCodStatoPagamento = {
  SUCCESSO: 'SUCCESSO',
  FALLIMENTO: 'FALLIMENTO',
  PENDENTE: 'PENDENTE',
  DA_PAGARE: 'DA-PAGARE',
} as const;
